import { Button } from "@chakra-ui/react";
import React from "react";
import { IProcessedAIFile } from "../../../types/common";
import { resolveMediaUrl } from "@/utils/resolveMediaUrl";

const DownloadFilesButton = ({
  processedFiles,
}: {
  processedFiles: IProcessedAIFile[];
}) => {
  const handleMultipleDownload = () => {
    processedFiles?.forEach(async (processedFile) => {
      const response = await fetch(resolveMediaUrl(processedFile.file.url));
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = processedFile.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  };

  if (!processedFiles) return null;

  return (
    <Button colorPalette="black" onClick={handleMultipleDownload}>
      Download
    </Button>
  );
};

export default DownloadFilesButton;
